const gradientClass =
  "bowlby-one-sc bg-clip-text text-transparent bg-[length:200%_100%] animate-[gradient_15s_linear_infinite]";
const gradientStyle = {
  backgroundImage: "linear-gradient(to right, #E14796, #48B9F8, #F16E80)",
};

export default function Hero() {
  return (
    <div className="relative flex flex-col items-center justify-center text-center text-white h-dvh overflow-hidden px-4">
      {/* Headline */}

      {/* Mobile layout */}
      <div className="bottom-32 absolute flex flex-col items-center gap-y-2 font-bold sm:hidden w-full">
        <div className="flex flex-row flex-wrap justify-center gap-x-2">
          {["sports", "markets"].map((word, i) => (
            <span
              key={i}
              className={`${gradientClass} text-4xl sm:text-5xl`}
              style={gradientStyle}
            >
              {word}.
            </span>
          ))}
        </div>
        <span
          className={`${gradientClass} text-6xl sm:text-[3.75rem]`}
          style={gradientStyle}
        >
          mashed.
        </span>
      </div>

      {/* Tablet & Desktop layout */}
      <div className="bottom-20 absolute hidden sm:flex flex-col sm:flex-row flex-wrap justify-center gap-x-2 text-5xl md:text-[6rem] font-bold md:mb-8">
        {["sports", "markets", "mashed"].map((word, i) => (
          <span key={i} className={gradientClass} style={gradientStyle}>
            {word}.
          </span>
        ))}
      </div>
    </div>
  );
}
